import { LosseFlexShell } from '@ubo/losse-sjedel'
import type { LosseFlexShellProps, LosseFlexShellType } from '@ubo/losse-sjedel'
import ContentDefault from './ContentDefault'
import ContentQuote from './ContentQuote'
import ContentUsp from './ContentUsp'
import ContentBlocks from './ContentBlocks'
import ContentSliderBlocks from './ContentSliderBlocks'
import ContentImageSlider from './ContentImageSlider'
import ContentCTA from './ContentCTA'
import ContentAccordion from './ContentAccordion'
import ContentWithCutoutImage from './ContentWithCutoutImage'
import ContentWithBlockImage from './ContentWithBlockImage'
import ContentVideoSlider from './ContentVideoSlider'
import ContentSteps from './ContentSteps'
import ContentVacancy from './ContentVacancy'
import ContentVideo from './ContentVideo'
import ContentUspBlocks from './ContentUspBlocks'
import ContentBlocksAlt from './ContentBlocksAlt'
import ContentCTABlock from './ContentCTABlock'
import ContentVideoAlt from './ContentVideoAlt'
import ContentCTABlockAlt from './ContentCTABlockAlt'
import ContentThanks from './ContentThanks'
import ContentCTAAlt from './ContentCTAAlt'

export default function ContentShell({ fields, index }: LosseFlexShellProps) {
  const types: LosseFlexShellType = {
    default: ContentDefault,
    quote: ContentQuote,
    usp: ContentUsp,
    blocks: ContentBlocks,
    sliderblocks: ContentSliderBlocks,
    sliderimages: ContentImageSlider,
    cta: ContentCTA,
    cta_alt: ContentCTAAlt,
    accordion: ContentAccordion,
    cutoutimage: ContentWithCutoutImage,
    blockimage: ContentWithBlockImage,
    videoslider: ContentVideoSlider,
    steps: ContentSteps,
    vacancy: ContentVacancy,
    content_video: ContentVideo,
    usp_blocks: ContentUspBlocks,
    blocks_alt: ContentBlocksAlt,
    cta_block: ContentCTABlock,
    video_alt: ContentVideoAlt,
    cta_block_alt: ContentCTABlockAlt,
    thanks: ContentThanks
  }

  return <LosseFlexShell types={types} fields={fields} index={index} />
}
